export default {
  add_rate: 'Add rate',
  remove_rate: 'Remove rate',
  gateways: {
    adyen: 'Adyen',
  },
  methods: {
    fallback: 'Any payment method',
    card: 'Card',
    apple_pay: 'Apple Pay',
    google_pay: 'Google Pay',
    link: 'Link',
    paypal: 'PayPal',
    pay_by_bank: 'Pay by Bank',
    sepa_debit: 'SEPA Direct Debit',
    sofort: 'Sofort',
    giropay: 'giropay',
    bacs_debit: 'Bacs Direct Debit',
    stripe_other: 'Other Stripe methods',
  },
  fields: {
    percentage: 'Percentage',
    fixed: 'Fixed amount',
    min: 'Minimum amount',
  },
  // Spelled out from the row's own values, so a rate reads as the fee it
  // produces. {{method}} is the payment method, {{fixed}}/{{floor}} are
  // formatted amounts, {{percentage}} is a plain number.
  explanation: {
    none: 'Nothing is charged on {{method}} yet — these payments earn a 0% margin until a rate is set.',
    floor_only: 'On {{method}} the processing fee is {{floor}} on every payment, whatever the order total.',
    percentage: 'On {{method}} the processing fee is {{percentage}}% of the order total.',
    percentage_floor: 'On {{method}} the processing fee is {{percentage}}% of the order total, and at least {{floor}}.',
    fixed: 'On {{method}} the processing fee is {{fixed}} per payment.',
    fixed_floor: 'On {{method}} the processing fee is {{fixed}} per payment, and at least {{floor}}.',
    combined: 'On {{method}} the processing fee is {{fixed}} fixed plus {{percentage}}% of the order total.',
    combined_floor:
      'On {{method}} the processing fee is {{fixed}} fixed plus {{percentage}}% of the order total, and at least {{floor}}.',
    redundant_floor:
      'The {{floor}} minimum never takes effect — the fixed amount already reaches it on every payment. Set it above {{fixed}} or clear it.',
  },
  example: 'Example: on a {{total}} order the processing fee is {{fee}}.',
};
